import React from 'react';

interface SectionHeadingProps {
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({ 
  children, 
  size = 'xl', 
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'text-2xl',
    md: 'text-3xl',
    lg: 'text-4xl',
    xl: 'text-5xl'
  };

  return (
    <h2 className={`${sizeClasses[size]} font-bold ${className}`}>
      {children}
    </h2>
  );
};
